

export const CONFIRM_TYPE_SMS_CODE = 1; // ������������� ����� ��� ���
export const CONFIRM_TYPE_USER_CALL = 2; // ������������� ����� ������ �� ������������
export const CONFIRM_TYPE_BOT_CALL = 3; // ������������� ����� ������ �� ����, ��� � ������ �������� ��������� ������
export const CONFIRM_TYPE_BOT_SPEECH = 4; // ������������� ����� ��������� ���
export const CONFIRM_TYPE_SIM_PUSH = 5; // ������������� ����� SIM-push

export const CONFIRM_TYPE_EMAIL_CODE = 44; // ������������� ����� Email ���

export const ACTION_TYPE_AUTH = 'AUTH'; // �����������
export const ACTION_TYPE_REG = 'REG'; // �����������
export const ACTION_TYPE_FORGET = 'FORGET'; // ������������� �������


export const AUTH_BY_PHONE = 'PHONE'; // ����������� �� ��������
export const AUTH_BY_PASSWORD= 'PASSWORD'; // ����������� �� ������
export const AUTH_BY_EMAIL_CODE= 'EMAIL_CODE'; // ����������� �� �����


export default {
    CONFIRM_TYPE_SMS_CODE,
    CONFIRM_TYPE_USER_CALL,
    CONFIRM_TYPE_BOT_CALL,
    CONFIRM_TYPE_BOT_SPEECH,
    CONFIRM_TYPE_SIM_PUSH,
    CONFIRM_TYPE_EMAIL_CODE,

    AUTH_BY_PHONE,
    AUTH_BY_PASSWORD,
    AUTH_BY_EMAIL_CODE,

    ACTION_TYPE_AUTH,
    ACTION_TYPE_REG,
    ACTION_TYPE_FORGET,


}